import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemMeta as RmwcListItemMeta} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-theme--on-${theme} &&& {
    color: var(--mdc-theme-on-${theme});
  }
`

const StyledRmwcListItemMeta = styled(RmwcListItemMeta)`
  ${theme({theme: 'primary'})};
`

const ListItemMeta = ({children, ...otherProps}) => <StyledRmwcListItemMeta {...otherProps}>{children}</StyledRmwcListItemMeta>

ListItemMeta.propTypes = {
  children: PropTypes.any
}

export {ListItemMeta}
